module.exports = __webpack_public_path__ + "img/GAME_BEAUTIFULFLOWER.e50c0fb4.png";